import * as React from 'react';
import { useSearch } from '@elastic/react-search-ui';
import downIcon from '../../../faceted-search/react/icons/angle-down.svg';
import { Config } from '../../helper';

export default function OpenSearchItemsPerPage(props) {
  const {
    itemsPerPage = Config.DisplayOptions.ItemsPerPage.DefaultValue,
  } = props;
  const {
    resultsPerPage,
    setResultsPerPage,
    setCurrent
  } = useSearch();

  const uniqueItemsPerPageValues = new Set([
    itemsPerPage,
    ...Config.DisplayOptions.ItemsPerPage.DefaultOptions
  ]);

  let options = Array.from(uniqueItemsPerPageValues.values());
  options.sort((a, b) => a - b);

  return (
    <div className='items-per-page'>
      <label>
        {Config.I18n.ResultsPerPage.Label}
        <span>
          <select
            value={resultsPerPage}
            onChange={e => {
              setResultsPerPage(Number(e.target.value));
              setCurrent(1);
            }}
          >
          {options.map(size => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
          <span className='items-per-page__arrow'>
          <img src={downIcon} alt=''/>
          </span>
        </span>
        {Config.I18n.ResultsPerPage.Unit}
      </label>
    </div>
  );
}
